<template>
  <div>
    <div class="report-header">
      <h1>Comp Set Report</h1>
      <button class="download-pdf-button" @click="downloadPDF">
        <i class="fas fa-file-pdf"></i> Download PDF
      </button>
    </div>
    
    <div id="report-content" class="svg-container">
      <div class="page-wrapper">
        <img src="@/assets/report/Reports - 1.svg" alt="Report 1" class="svg-image" />
      </div>
      <div class="page-wrapper page-break">
        <img src="@/assets/report/Reports - 2.svg" alt="Report 2" class="svg-image" />
      </div>
      <div class="page-wrapper page-break">
        <img src="@/assets/report/Reports - 3.svg" alt="Report 3" class="svg-image" />
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js';

export default {
  name: 'ReportPage',
  mounted() {
    // Auto-generate PDF when the page loads, but don't open a new tab
    // Check if this is the first load to avoid duplicate PDF generation
    if (!window.reportPdfGenerated) {
      window.reportPdfGenerated = true;
      this.generatePDF(false);
    }
  },
  methods: {
    downloadPDF() {
      this.generatePDF(true);
    },
    generatePDF(download = false) {
      // Wait for images to load
      setTimeout(() => {
        const element = document.getElementById('report-content');
        const opt = {
          margin: [15, 15, 15, 15], // [top, right, bottom, left] margins in mm
          filename: 'comp-set-report.pdf',
          image: { type: 'jpeg', quality: 1.0 },
          html2canvas: { 
            scale: 1.5, // Reduced scale for better fit
            useCORS: true,
            letterRendering: true,
            logging: false,
            imageTimeout: 0 // No timeout for images
          },
          jsPDF: { 
            unit: 'mm', 
            format: 'a4', 
            orientation: 'portrait',
            compress: true
          },
          // Prevent opening in a new window
          windowWidth: window.innerWidth,
          windowHeight: window.innerHeight,
          // Enable page breaks
          pagebreak: { mode: ['css', 'legacy'] }
        };

        try {
          // If download is true, trigger download, otherwise just generate
          if (download) {
            html2pdf()
              .from(element)
              .set(opt)
              .save();
          } else {
            // Just generate the PDF without downloading or opening a new tab
            html2pdf()
              .from(element)
              .set(opt)
              .outputPdf('blob')
              .then(blob => {
                // Store the blob in a global variable for later use if needed
                window.reportPdfBlob = blob;
                console.log('PDF generated successfully');
              })
              .catch(error => {
                console.error('Error generating PDF:', error);
              });
          }
        } catch (error) {
          console.error('Error in PDF generation:', error);
        }
      }, 2000); // Wait 2 seconds for images to load
    }
  }
}
</script>

<style scoped>
.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  margin-top: 40px;
}

.download-pdf-button {
  background-color: #4A5FD5;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.download-pdf-button:hover {
  background-color: #3a4db3;
}

.svg-container {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}

.page-break {
  page-break-before: always;
}

.svg-image {
  width: 100%;
  max-width: 60vw; /* Back to viewport-based for web display */
  height: auto;
  margin-bottom: 20px;
  object-fit: contain;
}

@media print {
  .report-header {
    display: none;
  }
  
  .page-wrapper {
    margin-bottom: 0;
  }
}
</style>